import { render, staticRenderFns } from "./ProjectServicesDetail.vue?vue&type=template&id=61e353d8&scoped=true&"
import script from "./ProjectServicesDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectServicesDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectServicesDetail.vue?vue&type=style&index=0&id=61e353d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e353d8",
  null
  
)

export default component.exports